module.exports = __webpack_public_path__ + "img/0S6A0272.ee6ea40a.jpg";